import React, { useEffect, useState } from 'react';
import './styles/pl_date_range_picker.scss';
import { DayPickerRangeController, FocusedInputShape } from 'react-dates';
import moment from 'moment-timezone';
import { Moment } from 'moment';
import { PLDateRangePickerProps } from './types';

const PLDateRangePicker = ({ startDate: inputStartDate, endDate: inputEndDate, onDatesChange, updateTable }: PLDateRangePickerProps) => {
	const [startDate, setStartDate] = useState<Moment | null>(inputStartDate);
	const [endDate, setEndDate] = useState<Moment | null>(inputEndDate);
	const [focusedInput, setFocusedInput] = useState<FocusedInputShape | null>('startDate');

	useEffect(() => onDatesChange({ startDate, endDate }), [startDate, endDate]);

	const onFocusChange = (focusedInput) => setFocusedInput(!focusedInput ? 'startDate' : focusedInput);
	const onChangeDates = ({ startDate, endDate }) => {
		setStartDate(startDate);
		setEndDate(endDate);
		updateTable();
	};

	return (
		<DayPickerRangeController
			startDate={startDate}
			endDate={endDate}
			onDatesChange={onChangeDates}
			focusedInput={focusedInput}
			onFocusChange={onFocusChange}
			initialVisibleMonth={() => moment()}
		/>
	);
};

export default PLDateRangePicker;
